import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Container from "@src/components/shared/Container";
import TitleAndDesc from "@src/components/shared/TitleAndDesc";
import { Button } from "@src/components/ui/button";
import animationData from "@src/assets/lottie/Warning.json";
import useZustandStore from "@src/helpers/zustand";
import Player from "lottie-react";

function IncompleteAttempt() {
  const { data: zData, clearData } = useZustandStore((state) => state);
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  useEffect(() => {
    clearData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <div className="py-6">
        <TitleAndDesc
          desc={t("incompletePage.desc")}
          title={t("incompletePage.title")}
        />
      </div>

      <>
        {location.search.includes("with_info") && (
          <div className="my-3 rounded-xl border border-solid border-gray-200 bg-gray-50 p-3">
            <p>{t("incompletePage.info")}</p>
          </div>
        )}
      </>
      <div className="flex flex-1 items-center justify-center max-md:min-h-[60vh]">
        <div className="mx-auto h-[180px] w-[180px]">
          <Player
            loop={false}
            autoplay={true}
            animationData={animationData}
            rendererSettings={{
              preserveAspectRatio: "xMidYMid slice",
            }}
          />
        </div>
      </div>

      <>
        {zData.errorMessage ? (
          <div className="my-3 rounded-xl border border-solid border-gray-200 bg-gray-50 p-3">
            <p>{zData.errorMessage || ""}</p>
          </div>
        ) : null}
      </>
      <Link to={`/${i18n.language}/review-details`}>
        <div
          className="w-full self-end rounded-[6px] bg-white py-8
       max-md:absolute max-md:bottom-0 max-md:left-0 max-md:right-0 max-md:px-4"
        >
          <Button className="w-full">{t("incompletePage.next")}</Button>
        </div>
      </Link>
    </Container>
  );
}

export default IncompleteAttempt;
